<template>
  <div data-test-id="modify-membership-form">
    <q-card
      class="fit col"
      flat
    >
      <q-card
        class="column"
      >
        <member-form
          v-show="showMemberForm"
          ref="memberForm"
          :embedded-in-model-table="false"

          @apply-changes="memberFormApplyChanges()"
          @add-model="memberFormApplyChanges()"
        />
        <div
          class="col-auto row q-ma-sm text-center items-center q-gutter-sm"
          style="max-height: 60px;"
        >
          <div
            class="col row justify-start items-center"
            style="flex-grow: 1"
          >
            <q-btn
              v-if="dialog"
              v-close-popup="dialog"
              flat
              round
              dense
              icon="close"
            />
          </div>
          <div
            class="col-auto text-h6 title"
            data-test-id="modify-membership-page-header"
          >
            {{ $t('pages.modifyMembership.heading') }}
          </div>
          <div
            class="col justify-end items-center"
            style="flex-grow: 1"
          />
        </div>
        <q-card-section
          class="col-auto column q-mb-lg"
          :class="{ 'q-mx-lg q-mt-lg': $q.screen.gt.xs }"
        >
          <q-list
            v-if="orderMember && orderMember.membership.members.data.length"
            bordered
            separator
          >
            <q-slide-item
              v-for="member in orderMember.membership.members.data"
              :key="member.id"
              right-color="negative"
              @right="details => removeMember(member, details.reset)"
              @click="editUser(member)"
            >
              <template
                #right
              >
                <q-icon
                  left
                  name="delete"
                />
                {{ $t('actions.remove') }}
              </template>

              <q-item
                class="row"
                :class="{ 'items-start': $q.screen.lt.sm }"
              >
                <div
                  class="col-7 row"
                  :class="{ 'q-gutter-x-sm q-gutter-y-sm': $q.screen.lt.sm }"
                >
                  <q-item-section
                    v-if="!$consumer"
                    class="col-auto"
                  >
                    <div
                      v-if="member.id === orderMember.membership.owner?.id"
                      data-test-id="owner-avatar"
                    >
                      <q-avatar
                        color="positive"
                        text-color="white"
                        :font-size="$q.screen.lt.sm ? '8px' : '10px'"
                        :size="$q.screen.lt.sm ? '26px' : '32px'"
                        class="text-bold"
                      >
                        {{ $t('common.owner') }}
                      </q-avatar>
                    </div>
                  </q-item-section>

                  <q-item-section>
                    <div
                      class="row items-center q-gutter-x-xs col-auto"
                      :class="{ 'q-mt-xs': $q.screen.lt.sm }"
                    >
                      <q-icon
                        v-if="memberErrors[member.id] || voucherErrors[member.id]"
                        class="col-auto"
                        size="sm"
                        name="error"
                        :color="memberErrors[member.id] ? 'negative' : 'warning'"
                      >
                        <q-tooltip :class="memberErrors[member.id] ? 'bg-negative' : 'bg-warning'">
                          {{ memberErrors[member.id] || voucherErrors[member.id] }}
                        </q-tooltip>
                      </q-icon>
                      <q-item-label
                        class="col text-uppercase"
                        overline
                      >
                        {{ member.name }}
                      </q-item-label>
                    </div>
                  </q-item-section>

                  <q-item-section
                    class="col-12 col-sm-6"
                    data-test-id="membership-type-chip-container"
                  >
                    <membership-type-chip
                      :style="{ 'max-width': $q.screen.xs ? '43vw' : undefined }"
                      :icon-right="'arrow_drop_down'"
                      :user="member"
                      :enable-set-for-all="false"
                      @select-membership-type="changeCount++"
                    />
                  </q-item-section>
                </div>

                <q-item-section
                  class="text-center text-body2 text-lowercase"
                  :class="{ 'col-auto': $q.screen.xs }"
                >
                  <i18n-n
                    :value="memberRateDisplayTotal(member)"
                    format="currency"
                    scope="global"
                  />/{{ orderMember.membership.termName }}
                </q-item-section>
                <q-item-section
                  class="col-auto"
                >
                  <q-btn
                    icon="edit"
                    color="grey"
                    flat
                    round
                    dense
                  >
                    <q-tooltip>
                      {{ $t('membership.editMemberDetailsTooltip') }}
                    </q-tooltip>
                  </q-btn>
                </q-item-section>
                <q-item-section
                  class="col-auto"
                >
                  <q-btn
                    icon="delete"
                    color="grey"
                    flat
                    round
                    dense
                    @click.stop="details => removeMember(member, details.reset)"
                  >
                    <q-tooltip>
                      {{ $t('membership.deleteMemberTooltip') }}
                    </q-tooltip>
                  </q-btn>
                </q-item-section>
              </q-item>
            </q-slide-item>
          </q-list>
          <div
            class="col-auto row justify-between text-center items-center q-mt-xs"
          >
            <div
              class="col-auto row justify-end"
              :class="$q.screen.gt.xs ? 'q-gutter-x-sm' : 'q-gutter-x-xs'"
              :style="{ 'width': $q.screen.gt.xs ? 'auto' : '100%' }"
            >
              <q-btn
                v-if="!loading && !hasSingleMemberLimit && isAdminOrRegister"
                :style="{ 'width': $q.screen.gt.xs ? '160px' : '100%' }"
                :disable="hasMaximumMembers"
                @click="searchForMember"
              >
                <template #default>
                  <div
                    class="row items-center q-gutter-x-xs"
                  >
                    <q-icon
                      name="people_outline"
                    />
                    <span>
                      {{ $t('membership.actions.findMember') }}
                    </span>
                  </div>
                </template>
              </q-btn>
              <q-btn
                v-if="!hasSingleMemberLimit"
                :style="{ 'width': $q.screen.gt.xs ? '160px' : '100%' }"
                :disable="hasMaximumMembers"
                @click="$refs.addMembersDialog.show()"
              >
                <template #default>
                  <div
                    class="row items-center q-gutter-x-xs"
                  >
                    <q-icon
                      name="person_add_alt"
                    />
                    <span>
                      {{ $tc('membership.actions.addMember', 2) }}
                    </span>
                  </div>
                </template>
              </q-btn>
            </div>
            <q-btn
              v-if="!$admin && !showVoucherUid && currentCircuit.hasMembershipVouchers"
              :style="{ 'width': $q.screen.gt.xs ? '' : '100%' }"
              :background-color="!invalidVoucherTerm && $_.values(voucherErrors).length === 0 ? 'primary' : 'negative'"
              @click="showVoucherUid = true"
            >
              <template #default>
                <div
                  class="row items-center q-gutter-x-xs"
                >
                  <q-icon
                    name="sell"
                  />
                  <span>
                    {{ voucherButtonLabel }}
                  </span>
                </div>
                <q-tooltip
                  v-if="invalidVoucherTerm || $_.values(voucherErrors) !== 0"
                  class="bg-negative"
                >
                  {{ $t('membership.errors.invalidMembershipVoucher') }}
                </q-tooltip>
              </template>
            </q-btn>

            <checkout-code-input
              v-else-if="!$admin"
              class="q-px-none"
              :class="$q.screen.xs ? 'full-width' : undefined"
              @add-checkout-code="code => $emit('add-checkout-code', code)"
            />
          </div>
        </q-card-section>
        <q-card-section
          v-if="orderMember && orderMember.id !== orderMember.membership.owner?.id"
          class="col"
        >
          <div class="text-center q-mb-lg text-h6 text-negative">
            {{ $consumer ? $t('membership.errors.currentUserIsNotOwner') : $t('membership.errors.selectedUserIsNotOwner') }}
          </div>
          <div class="row justify-center q-gutter-sm">
            <div>
              <q-btn
                :label="$consumer ? $t('membership.actions.leaveAndStartSeparatePlan') : $t('membership.actions.removeNameAndStartSeparatePlane', { name: orderMember.firstName })"
                color="warning"
                outline
                :disable="orderMember.membership.state === 'active' && (orderMember.membershipType && !orderMember.membershipType.default)"
                @click="createSeparateMembership(orderMember)"
              />
              <q-tooltip v-if="orderMember.membership.state === 'active' && (orderMember.membershipType && !orderMember.membershipType.default)">
                {{ $consumer ? $t('membership.youAreOnActivePlanTooltip') : $t('membership.nameIsOnActivePlanTooltip', { name: orderMember.firstName }) }}
              </q-tooltip>
            </div>
            <q-btn
              v-if="isAdminOrRegister"
              :label="$t('membership.actions.selectOwner')"
              color="secondary"
              outline
              @click="$emit('select-user', orderMember.membership.owner)"
            />
            <div>
              <q-btn
                v-if="isAdminOrRegister"
                :label="$t('membership.actions.makeNameOwner', { name: orderMember.firstName })"
                color="primary"
                outline
                :disable="!orderMember.canBeMembershipOwner"
                @click="setOwner(orderMember)"
              />
              <q-tooltip v-if="!orderMember.canBeMembershipOwner">
                {{ cannotBeMembershipOwnerReason(orderMember) }}
              </q-tooltip>
            </div>
          </div>
        </q-card-section>
        <q-card-actions
          v-if="orderMember && orderMember.id === orderMember.membership.owner?.id"
          class="col row justify-between items-center text-center q-gutter-y-xl "
          :class="{ 'q-mx-xl': $q.screen.gt.xs }"
          :style="$q.screen.xs ? 'padding-bottom: 80px;' : ''"
          :vertical="$q.screen.xs"
        >
          <div
            v-if="$q.screen.gt.xs"
            class="col-auto justify-end text-h5"
          >
            <i18n-n
              :value="membershipRateDisplayTotal(orderMember.membership)"
              format="currency"
              scope="global"
            />
            / {{ orderMember.membership.termName }}
          </div>
          <div
            :class="($q.screen.xs ? 'column' : 'row') + ' col row justify-end items-center q-gutter-md q-mt-lg'"
            style="flex-grow: 1"
          >
            <iso-date-input
              v-if="$admin"
              v-model="adminEndDate"
              class="q-pb-none"
              :label="$t('time.endDate')"
              dense
              :date-picker-props="{ options: (date) => date >= todayString }"
            />
            <q-btn
              :style="{ 'width': $q.screen.gt.xs ? '200px' : '100%' }"
              outline
              :text-color="invalidTerm ? 'negative' : ''"
              :size="$q.screen.gt.xs ? 'md' : 'lg'"
              @click="$refs.selectTermDialog.show()"
            >
              <template #default>
                <div class="row items-center q-gutter-x-sm">
                  <q-icon
                    v-if="invalidTerm"
                    name="error"
                    color="negative"
                    size="xs"
                  >
                    <q-tooltip class="bg-negative">
                      {{ $t('membership.invalidRenewalPeriodTooltip') }}
                    </q-tooltip>
                  </q-icon>
                  <span>
                    {{ $t('membership.actions.renewTerm', { term: orderMember.membership.termName }) }}
                  </span>
                  <q-icon
                    class="q-ml-none"
                    name="arrow_drop_down"
                  />
                </div>
              </template>
            </q-btn>
            <div
              v-if="$q.screen.xs"
              class="col text-h5"
            >
              <i18n-n
                :value="membershipRateDisplayTotal(orderMember.membership)"
                format="currency"
                scope="global"
              />
              / {{ orderMember.membership.termName }}
            </div>
            <q-btn
              class="gt-xs"
              style="width: 150px;"
              color="primary"
              :text-color="buttonTextColor(currentSite.primaryColor)"
              :disable="$_.values(memberErrors).length > 0"
              data-test-id="modify-membership-form-checkout-button"
              @click="checkout"
            >
              <template #default>
                <div
                  v-if="$_.values(memberErrors).length > 0"
                  class="row items-center q-gutter-x-xs"
                >
                  <q-icon
                    name="shopping_cart"
                  />
                  <span>
                    {{ checkoutLabel }}
                  </span>
                  <q-tooltip>
                    {{ $t('membership.fixCheckoutErrorsTooltip') }}
                  </q-tooltip>
                </div>
                <div
                  v-else
                  class="row items-center q-gutter-x-xs"
                >
                  <q-icon
                    name="shopping_cart"
                  />
                  <span>
                    {{ checkoutLabel }}
                  </span>
                </div>
              </template>
            </q-btn>
          </div>
        </q-card-actions>
      </q-card>
      <q-inner-loading :showing="loading" />
    </q-card>
    <q-dialog
      v-model="showSearchForMember"
      data-test-id="search-for-member-dialog"
    >
      <q-card
        v-if="!loading && isAdminOrRegister"
        style="width: 50%; max-width: 350px;"
      >
        <q-card-section
          class="row items-center q-mx-xs"
        >
          <div class="text-h6">
            {{ $t('membership.searchForMemberDialogHeading') }}
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section>
          <div
            class="row q-col-gutter-md"
          >
            <q-select
              v-if="isAdminOrRegister"
              :model-value="null"
              :label="$t('membership.actions.findExistingMember')"
              outlined
              :use-input="true"
              class="q-mr-md full-width"
              input-debounce="300"
              :options="users.data"
              input-style="search"
              autofocus
              @filter="filterUsers"
              @update:model-value="user => selectUser(user)"
            >
              <template #no-option>
                <q-item>
                  <q-item-section class="text-grey">
                    {{ $t('search.noResults') }}
                  </q-item-section>
                </q-item>
              </template>
              <template #option="scope">
                <q-item
                  v-bind="scope.itemProps"
                  v-on="scope.itemEvents"
                >
                  <q-item-section avatar>
                    <q-img
                      no-spinner
                      no-transition
                      width="30px"
                      :src="scope.opt.photoSmallUrl"
                    />
                  </q-item-section>
                  <q-item-section>
                    {{ scope.opt.name }}
                  </q-item-section>
                </q-item>
              </template>
            </q-select>
            <div
              v-if="memberSearchMessage"
              class="text-negative"
            >
              {{ memberSearchMessage }}
            </div>
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <div>
            <q-btn
              :label="$t('actions.addNew')"
              :disable="hasMaximumMembers"
              @click="addNewMember"
            />
            <q-tooltip v-if="hasMaximumMembers">
              {{ $t('membership.memberLimitCountTooltip', { count: currentCircuit.membershipMemberLimit }) }}
            </q-tooltip>
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog
      v-model="showRemoveMemberDialog"
      @hide="resetMemberToRemove"
    >
      <q-card>
        <q-card-section
          class="row items-center q-mx-xs"
        >
          <div class="text-h6">
            {{ $t('membership.actions.removeMember') }}
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section
          class="row items-center q-mx-xs"
        >
          <div v-if="memberToRemove && memberToRemove.value.membershipType.default">
            {{ $t('membership.removeMemberPrompt') }}
          </div>
          <div v-else>
            {{ $t('membership.removeOrDowngradeMemberPrompt') }}
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            v-close-popup
            :label="$t('membership.actions.removeMember')"
            color="secondary"
            :text-color="buttonTextColor(currentSite.secondaryColor)"
            @click="orderMember.membership.members.remove(memberToRemove.value)"
          />
          <q-btn
            v-if="memberToRemove && !memberToRemove.value.membershipType.default"
            v-close-popup
            :label="$t('membership.actions.basicMember')"
            color="primary"
            :text-color="buttonTextColor(currentSite.primaryColor)"
            @click="basicifyMember(memberToRemove.value, memberToRemove.reset)"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="showPeriodStrategyDialog">
      <q-card>
        <q-card-section
          class="row items-center q-mx-xs"
        >
          <div class="text-h6">
            {{ $t('membership.periodStrategyDialogHeading') }}
          </div>
          <q-space />
          <q-btn
            v-close-popup
            icon="close"
            flat
            round
            dense
          />
        </q-card-section>
        <q-card-section
          class="row items-center q-mx-xs"
        >
          <div>
            {{ $t('membership.periodStrategyDialogPrompt') }}
          </div>
        </q-card-section>
        <q-card-actions class="row justify-end q-ma-sm">
          <q-btn
            v-close-popup
            :label="$t('actions.prorate')"
            color="secondary"
            :text-color="buttonTextColor(currentSite.secondaryColor)"
            @click="periodStrategy = MEMBERSHIP_PERIOD_STRATEGIES.PRORATE; checkout();"
          />
          <q-btn
            v-close-popup
            :label="$t('actions.replace')"
            color="primary"
            :text-color="buttonTextColor(currentSite.primaryColor)"
            @click="periodStrategy = MEMBERSHIP_PERIOD_STRATEGIES.REPLACE; checkout();"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <add-members-dialog
      v-if="orderMember"
      ref="addMembersDialog"
      :member="orderMember"
    />
    <select-term-dialog
      v-if="orderMember"
      ref="selectTermDialog"
      :membership="orderMember.membership"
      @select-term="changeCount++"
    />
    <voucher-package-dialog
      ref="voucherPackageDialog"
      :order="order"
      destroy-on-close
      @add-voucher="applySpecificMembershipVoucher()"
      @add-voucher-package="applySpecificMembershipVoucher()"
    />
  </div>
</template>

<script>
import { date, Notify } from 'quasar'
const { addToDate, formatDate } = date
import { isAdmin, isPos } from 'src/config'
import CheckoutCode, { CHECKOUT_CODE_TYPES } from 'src/models/checkout-code/CheckoutCode'
import Membership, { MEMBERSHIP_PERIOD_STRATEGIES } from 'src/models/membership/Membership'
import Order from 'src/models/order/Order'
import User, { USER_TYPES } from 'src/models/user/User'
import IsoDateInput from 'src/modules/admin/components/IsoDateInput'
import VoucherPackageDialog from 'src/modules/checkout/components/VoucherPackageDialog'
import CheckoutCodeInput from 'src/modules/register/components/cart/CheckoutCodeInput'
import AddMembersDialog from 'src/modules/register/membership/AddMembersDialog'
import MemberForm from 'src/modules/register/membership/MemberForm'
import MembershipTypeChip from 'src/modules/register/membership/MembershipTypeChip'
import SelectTermDialog from 'src/modules/register/membership/SelectTermDialog'

const todayString = formatDate(new Date(), 'YYYY/MM/DD')

export default {
  name: 'ModifyMembershipForm',
  components: {
    MemberForm,
    MembershipTypeChip,
    AddMembersDialog,
    IsoDateInput,
    SelectTermDialog,
    VoucherPackageDialog,
    CheckoutCodeInput
  },
  context: ['currentUser'],
  configuration: ['currentSite', 'currentCircuit', 'membershipTypes', 'userClasses'],
  props: {
    order: {
      type: Order,
      required: true
    },
    dialog: {
      type: Boolean,
      required: false,
      default: false
    },
    recaptchaTokenProvider: {
      type: Function,
      required: false,
      default: null
    }
  },
  emits: ['add-checkout-code', 'select-user', 'membership-validated', 'membership-voucher-validated', 'membership-order-created'],
  data () {
    return {
      creating: false,
      showMemberForm: false,
      memberToRemove: null,
      showRemoveMemberDialog: false,
      showSearchForMember: false,
      searchingForMember: false,
      memberSearchMessage: null,
      savingOwner: false,
      userSearchString: '',
      showPeriodStrategyDialog: false,
      periodStrategy: null,
      adminEndDate: null,
      changeCount: 0,
      userClassErrors: {},
      memberErrors: {},
      voucherErrors: {},
      invalidTerm: false,
      invalidVoucherTerm: false,
      guestsByUserClass: {},
      loading: true,
      specificMembershipVoucher: null,
      voucherButtonLabel: this.$t('voucher.actions.use'),
      showVoucherUid: false,
      voucherUid: '',
      voucherInputLabel: this.$t('voucher.actions.enterCode'),
      voucherInputLoading: false,
      hasSetInitialValues: false
    }
  },
  models: {
    users: {
      fields: 'search',
      variables () {
        return {
          searchString: this.userSearchString,
          orderBy: 'selectedAt',
          descending: true,
          limit: 30
        }
      },
      skip: !isPos && !isAdmin
    }
  },
  computed: {
    isAdminOrRegister () {
      return this.$register || this.$admin
    },
    checkoutLabel () {
      if (this.$admin) {
        return this.$t('actions.review')
      } else {
        return this.$t('checkout.actions.checkout')
      }
    },
    orderMember () {
      return _.find(this.order?.user?.membership?.members?.data, member => member.id === this.order?.user?.id)
    },
    hasSingleMemberLimit () {
      return this.currentCircuit?.enableMembershipMemberLimit && this.currentCircuit?.membershipMemberLimit <= 1
    },
    hasMaximumMembers () {
      return this.currentCircuit?.enableMembershipMemberLimit &&
            this.orderMember?.membership?.members?.data?.length >= this.currentCircuit?.membershipMemberLimit
    },
    terms () {
      const terms = []
      const ownerMembershipType = this.orderMember.membership.owner?.membershipType

      let allowMonthlyMembership = this.currentCircuit.allowMonthlyMembership
      let allowQuarterlyMembership = this.currentCircuit.allowQuarterlyMembership
      let allowBiannualMembership = this.currentCircuit.allowBiannualMembership
      let allowAnnualMembership = this.currentCircuit.allowAnnualMembership

      _.each(this.membershipTypes.data, membershipType => {
        if (this.$consumer && !membershipType.availableOnline && !membershipType.allowRenewalOnline) {
          return
        }

        if (membershipType.allowMonthlyMembership) {
          allowMonthlyMembership = true
        }
        if (membershipType.allowQuarterlyMembership) {
          allowQuarterlyMembership = true
        }
        if (membershipType.allowBiannualMembership) {
          allowBiannualMembership = true
        }
        if (membershipType.allowAnnualMembership) {
          allowAnnualMembership = true
        }
      })

      if (allowMonthlyMembership && (!ownerMembershipType?.hasYearlyTicketVouchers || ownerMembershipType?.hasMonthlyTicketVouchers)) {
        terms.push(1)
      }

      if (allowQuarterlyMembership && (!ownerMembershipType?.hasYearlyTicketVouchers || ownerMembershipType?.hasMonthlyTicketVouchers)) {
        terms.push(3)
      }

      if (allowBiannualMembership && (!ownerMembershipType?.hasYearlyTicketVouchers || ownerMembershipType?.hasMonthlyTicketVouchers)) {
        terms.push(6)
      }

      if (allowAnnualMembership) {
        terms.push(12)
      }

      return terms
    },
    membershipPeriod () {
      return this.orderMember?.membership?.term || this.currentCircuit.membershipRateDisplayPeriod || 1
    }
  },
  watch: {
    'orderMember.membership.owner.id': {
      async handler () {
        await this.$nextTick()
        this.loading = !this.orderMember || !!this.orderMember.membership.owner?.isLocal
      },
      immediate: true
    },
    loading: {
      handler () {
        if (!this.loading) {
          this.validateMembership()
          this.changeCount++
        }
      },
      immediate: true
    },
    changeCount: {
      async handler () {
        if (this.loading) return

        if (!this.orderMember) return

        if (!this.hasSetInitialValues && this.$route.query.voucher) {
          this.loading = true
          this.voucherUid = this.$route.query.voucher
          try {
            await this.findVoucher()
          } finally {
            this.hasSetInitialValues = true
            this.loading = false
          }
        }

        if (!this.hasSetInitialValues) {
          if (this.$route.query['user-class-id']) {
            const userClassId = +this.$route.query['user-class-id']

            // Set all existing members to specified user class
            _.each(this.orderMember.membership.members.data, member => {
              member.userClassId = userClassId
            })
          }

          if (this.$route.query.members) {
            const userClassId = this.$route.query['user-class-id'] ? +this.$route.query['user-class-id'] : this.orderMember.userClassId || this.userClasses.defaultUserClass?.id

            const membersRequired = +this.$route.query.members - this.orderMember.membership.members.data.length
            const guestsToAdd = Math.max((this.currentCircuit.enableMembershipMemberLimit ? Math.min((this.currentCircuit.membershipMemberLimit - this.orderMember.membership.members.data.length), membersRequired) : membersRequired), 0)

            this.guestsByUserClass[userClassId] = guestsToAdd
            this.createGuests()
          }

          if (this.$route.query['membership-term']) {
            this.orderMember.membership.term = +this.$route.query['membership-term']
          }

          if (this.$route.query['membership-type-id']) {
            const membershipType = _.find(this.membershipTypes.data, { id: +this.$route.query['membership-type-id'] })
            if (membershipType?.availableOnline) {
              if (membershipType.hasUserClassForUser(this.order.user)) {
                this.order.user.membershipType = membershipType
              }
              _.each(this.orderMember.membership.members.data, member => {
                if (membershipType.hasUserClassForUser(member)) {
                  member.membershipType = membershipType
                }
              })
            }
          }

          if (this.$admin) {
            this.adminEndDate = this.orderMember.membership.currentMembershipInterval?.endDate || addToDate(new Date(), { month: this.orderMember.membership.term })
          }

          this.hasSetInitialValues = true
        }

        // Update the order user with an updated phone (this is required because to prevent asking again
        // on the payment screen if it was provided here)
        this.order.user.phone = this.orderMember.phone

        this.validateMembershipErrors()
      },
      immediate: true
    }
  },
  created () {
    // This page requires the user be logged in. If the not logged in,
    // save the route and navigate to sign up
    if (!this.currentUser) {
      this.$auth.setPostAuthRoute(this.$router.currentRoute.value)
      this.$router.replace('/register')
      return
    }

    this.loading = this.order?.user?.membership?.owner?.id < 0
    _.extend(this, { todayString, MEMBERSHIP_PERIOD_STRATEGIES, USER_TYPES, User })

    const userId = this.order.user.id
    const orderId = this.order.id
    const membershipId = this.order.user.membership.id
    this.$trackPage(
      this,
      {
        name: 'ModifyMembershipForm',
        userId,
        orderId,
        membershipId
      }
    )
  },
  methods: {
    buttonTextColor (color) {
      return this.$isColorDark(color) ? 'white' : 'black'
    },
    validateMembershipErrors () {
      if (!this.orderMember) return

      // If not register check if we allow renewal of this membership type online
      if (!this.isAdminOrRegister && this.orderMember.membershipType && !this.orderMember.membershipType.availableOnline && !this.orderMember.membershipType.allowRenewalOnline) {
        this.memberErrors[this.orderMember.id] = this.$t('membership.errors.cannotModifyOnline')
        return
      }

      let anyInvalidTerm = false

      _.each(this.orderMember.membership.members.data, member => {
        let hasMemberError = false
        let hasVoucherError = false

        if ((this.orderMember.membership.term === 1 && !member.membershipType.allowMonthlyMembership) ||
              (this.orderMember.membership.term === 3 && !member.membershipType.allowQuarterlyMembership) ||
              (this.orderMember.membership.term === 6 && !member.membershipType.allowBiannualMembership) ||
              (this.orderMember.membership.term === 12 && !member.membershipType.allowAnnualMembership)
        ) {
          this.memberErrors[member.id] = this.$t('membership.errors.typeNotAvailableForSelectedRenewalPeriod', { type: member.membershipType.name })
          anyInvalidTerm = true
          hasMemberError = true
        }

        if (!!this.specificMembershipVoucher && member.membershipType.id !== this.specificMembershipVoucher.voucherType.membershipType.id) {
          if (!this.specificMembershipVoucher.voucherType.membershipType.hasUserClassForUser(member)) {
            this.voucherErrors[member.id] = this.$t('membership.errors.voucherMembershipTypeNotAvailableForName', { type: this.specificMembershipVoucher.voucherType.membershipType.name, name: member.name })
          } else {
            this.voucherErrors[member.id] = ` ${this.$t('membership.errors.nameMembershipTypeNotAvailableForVoucher', { name: member.name, type: this.specificMembershipVoucher.voucherType.membershipType.name })}`
          }
          hasVoucherError = true
        }

        if (!hasMemberError) delete this.memberErrors[member.id]
        if (!hasVoucherError) delete this.voucherErrors[member.id]
      })

      this.invalidTerm = anyInvalidTerm
      if (this.invalidTerm) {
        this.$mh.error(this.$t('membership.errors.selectedTypeNotAvailableForRenewalPeriod'))
      }
      this.$emit('membership-validated', _.values(this.memberErrors).length === 0)
      if (_.values(this.memberErrors).length !== 0) {
        _.each(_.values(this.memberErrors), error => this.$mh.error(error))
      }

      this.invalidVoucherTerm = !!this.specificMembershipVoucher && this.orderMember.membership.term > this.specificMembershipVoucher.voucherType.membershipTerm
      if (this.invalidVoucherTerm) {
        this.$mh.notify(this.$t('membership.errors.selectedRenewalPeriodNotAvailableForVoucher'), 'warning', 'top')
      }
      this.$emit('membership-voucher-validated', _.values(this.voucherErrors).length === 0)
      if (_.values(this.voucherErrors).length !== 0) {
        _.each(_.values(this.voucherErrors), error => this.$mh.notify(error, 'warning', 'top'))
      }
    },
    validateMembership () {
      if (!this.orderMember) return

      _.each(this.orderMember.membership.members.data, member => {
        // Validate member has userclass
        if (!member.userClass || member.userClassId <= 0) {
          member.userClassId = this.userClasses.defaultOnlineUserClass?.id || this.userClasses.defaultUserClass?.id || member.userClassId
        }

        // Validate member has appropriate membership type
        if (member.membershipType.isLocal || member.membershipType.hide || !member.membershipType.hasUserClassForUser(member)) {
          let newMembershipType = _.find(this.membershipTypes.data, membershipType => {
            return !!membershipType.membershipUserTypeForUser(member) && !membershipType.hide && !membershipType.free && (membershipType.availableOnline || this.isAdminOrRegister)
          })

          if (!newMembershipType) {
            newMembershipType = _.find(this.membershipTypes.data, membershipType => {
              return membershipType.hasUserClassForUser(member) && !membershipType.hide && (membershipType.availableOnline || this.isAdminOrRegister)
            })
          }

          member.membershipType = newMembershipType
        }
      })

      // Validate membership has an available term
      if (this.terms.length && !_.includes(this.terms, this.orderMember.membership.term)) {
        this.orderMember.membership.term = _.last(this.terms)
      }
    },
    memberFormApplyChanges () {
      this.showMemberForm = false
      this.changeCount++
    },
    async selectUser (user) {
      const userDetails = new User({ id: user.id },
        {
          membership: {
            currentMembershipInterval: 'default'
          },
          userClass: true,
          membershipType: true
        }
      )
      await userDetails.fetch()
      this.foundUser(userDetails)
    },
    removeMember (member, reset) {
      this.memberToRemove = {
        value: member,
        reset
      }
      this.showRemoveMemberDialog = true
    },
    resetMemberToRemove () {
      if (this.memberToRemove.reset) this.memberToRemove.reset()
    },
    basicifyMember (member, reset) {
      if (reset) reset()

      this.showRemoveMemberDialog = false
      member.membershipType = _.find(this.membershipTypes.data, membershipType => membershipType.default)
    },
    foundUser (user) {
      if (user.membership.state === 'active' && (user.membershipType && !user.membershipType.default)) {
        this.memberSearchMessage = this.$t('membership.errors.userHasPaidMembership')
      } else {
        // Don't add a second copy of a member already on this membership
        if (!_.includes(_.map(this.orderMember.membership.members.data, member => member.id), user.id)) {
          this.orderMember.membership.members.add(user)
          user.membership = this.orderMember.membership
          this.$refs.memberForm.validateMembershipTypes(user)
          this.$refs.memberForm.validateUserClasses(user)
        }
        this.showSearchForMember = false
      }
    },
    filterUsers (val, update, abort) {
      update(() => {
        this.userSearchString = val
      })
    },
    editUser (user, initialData = {}) {
      this.showMemberForm = true
      user.membership = !user.membership || user.membership.copy() // Need to unset or when the member form gets destroyed, so will the membership model
      this.$refs.memberForm.show(user, initialData)
      this.$refs.memberForm.validateUserClasses(user)
    },
    async setOwner (member) {
      this.savingOwner = true

      const membership = new Membership({
        id: this.orderMember.membership.id,
        owner: member
      }, {
        fields: ['id', 'owner']
      })
      await membership.save()

      this.savingOwner = false
    },
    addNewMember () {
      if (this.hasMaximumMembers) return

      this.showSearchForMember = false
      const newUser = new User({}, {
        parent: this.orderMember.membership.members,
        membership: this.orderMember.membership
      })
      this.$refs.memberForm.validateMembershipTypes(newUser)
      this.$refs.memberForm.validateUserClasses(newUser)
      this.editUser(newUser)
    },
    searchForMember () {
      this.memberSearchMessage = ''
      this.showSearchForMember = true
    },
    async createSeparateMembership (user) {
      const newMembershipUser = new User({
        id: user.id,
        membership: null
      }, {
        fields: ['id', 'membership']
      })

      await newMembershipUser.save()
      await this.orderMember.fetch(true)
    },
    memberRateDisplayTotal (member) {
      return member?.membershipMonthlyRate * this.membershipPeriod
    },
    membershipRateDisplayTotal (membership) {
      return membership.monthlyRate * this.membershipPeriod
    },
    createGuests () {
      _.each(this.guestsByUserClass, (guestCount, userClassId) => {
        for (let i = 0; i < guestCount; i++) {
          const newUser = new User({
            parent: this.orderMember.membership.members,
            membership: this.orderMember.membership,
            membershipTypeId: this.orderMember.membershipType.id, // Match the membershipType of the owning member
            type: USER_TYPES.GUEST,
            userClassId
          })

          let routeMembershipType = null
          if (this.$route.query['membership-type-id']) {
            routeMembershipType = _.find(this.membershipTypes.data, { id: +this.$route.query['membership-type-id'] })
            if (routeMembershipType.availableOnline && routeMembershipType.hasUserClassForUser(newUser)) {
              newUser.membershipType = routeMembershipType
            }
          }

          if (!this.orderMember.membershipType.hasUserClassForUser(newUser) && !routeMembershipType?.availableOnline) {
            // If the membershipType of the owning member is invalid for the Guest's userclass,
            // use the first applicable membershipType, preferring paid membershipTypes
            newUser.membershipType =
            _.find(this.membershipTypes.data, membershipType =>
              !membershipType.free &&
              !membershipType.hide &&
              (membershipType.availableOnline || this.isAdminOrRegister) &&
              membershipType.membershipUserTypeForUser(newUser)) ??
            _.find(this.membershipTypes.data, membershipType => membershipType.default)
          }

          this.orderMember.membership.members.add(newUser)
        }
      })

      this.guestsByUserClass = {}
      this.forceUpdateTermOptions++
    },
    async findVoucher () {
      if (this.voucherUid === '') return

      this.voucherInputLoading = true

      let recaptchaToken = null
      if (!_.isNil(this.recaptchaTokenProvider)) {
        recaptchaToken = await this.recaptchaTokenProvider()
      }

      const checkoutCode = new CheckoutCode({}, {
        queryName: 'validateCheckoutCode',
        voucher: {
          issuedVoucherPackage: {
            vouchers: 'default'
          }
        },
        giftCard: 'default',
        issuedVoucherPackage: {
          vouchers: 'default'
        },
        discount: 'default',
        voucherType: 'default',
        variables: {
          code: this.voucherUid,
          recaptchaToken
        }
      })

      try {
        await checkoutCode.fetch(true)

        if (checkoutCode.codeType === CHECKOUT_CODE_TYPES.ISSUED_VOUCHER_PACKAGE) {
          const issuedVoucherPackage = checkoutCode.issuedVoucherPackage
          if (issuedVoucherPackage?.uid) {
            this.$refs.voucherPackageDialog.show(issuedVoucherPackage.clone())
            this.showVoucherUid = false
            this.voucherInputLabel = this.$t('voucher.actions.enterCode')
            this.voucherUid = ''
            this.voucherInputLoading = false
            return true
          } else {
            this.voucherInputLabel = this.$t('voucherPackage.errors.invalidPackage')
            this.voucherInputLoading = false
            return false
          }
        } else if (checkoutCode.codeType === CHECKOUT_CODE_TYPES.VOUCHER) {
          const voucher = checkoutCode.voucher

          if (voucher?.issuedVoucherPackage) {
            this.$refs.voucherPackageDialog.show(voucher.issuedVoucherPackage.clone())
            this.showVoucherUid = false
            this.voucherInputLabel = this.$t('voucher.actions.enterCode')
            this.voucherUid = ''
            this.voucherInputLoading = false
            return true
          } else if (voucher?.uid) {
            if (voucher.state === 'expired') {
              Notify.create({
                timeout: 3000,
                message: this.$t('voucher.errors.hasExpired'),
                type: 'negative',
                position: 'top'
              })
            } else if (voucher.state !== 'valid') {
              Notify.create({
                timeout: 3000,
                message: this.$t('voucher.errors.notValid'),
                type: 'negative',
                position: 'top'
              })
            } else {
              this.order.applyIndependentVoucher(voucher.clone())
              this.applySpecificMembershipVoucher()
            }

            this.showVoucherUid = false
            this.voucherInputLabel = this.$t('voucher.actions.enterCode')
            this.voucherUid = ''
            this.voucherInputLoading = false
            return true
          }

          this.voucherInputLabel = this.$t('voucher.errors.invalid')
          this.voucherInputLoading = false
          return false
        }
      } finally {
        checkoutCode.destroy()
      }
    },
    applySpecificMembershipVoucher () {
      this.specificMembershipVoucher = this.order.specificMembershipVoucher

      if (this.specificMembershipVoucher) {
        this.voucherButtonLabel = this.specificMembershipVoucher.voucherType.name
        if (this.specificMembershipVoucher.voucherType.membershipType.membershipUserTypeForUser(this.order.user)) {
          this.order.user.membershipType = this.specificMembershipVoucher.voucherType.membershipType
        }
        _.each(this.orderMember.membership.members.data, member => {
          if (this.specificMembershipVoucher.voucherType.membershipType.membershipUserTypeForUser(member)) {
            member.membershipType = this.specificMembershipVoucher.voucherType.membershipType
          }
        })
        this.orderMember.membership.term = this.specificMembershipVoucher.voucherType.membershipTerm

        this.validateMembership()
        this.validateMembershipErrors()
        this.$nextTick(() => {
          if (!this.invalidTerm &&
              !this.invalidVoucherTerm &&
              _.values(this.memberErrors).length === 0 &&
              _.values(this.voucherErrors).length === 0) {
            this.checkout()
          }
        })
      }
    },
    async checkout () {
      // If a Period Strategy is not and can be selected, prompt for period strategy
      if (!this.periodStrategy) {
        const canAppend = this.currentCircuit.appendMemberships && !_.some(this.order.user.membership.members.describeDirty, memberChanges => _.values(memberChanges).length > 1)
        if (canAppend) {
          this.periodStrategy = MEMBERSHIP_PERIOD_STRATEGIES.APPEND
        } else if (this.currentCircuit.prorateMemberships && this.currentCircuit.replaceMemberships) {
          this.showPeriodStrategyDialog = true
          return
        } else {
          this.periodStrategy = this.currentCircuit.prorateMemberships ? MEMBERSHIP_PERIOD_STRATEGIES.PRORATE : MEMBERSHIP_PERIOD_STRATEGIES.REPLACE
        }
      }

      this.loading = true
      this.orderMember.membership.id = this.order.user.membership.id // In case the membership was copied for user editing
      const { order, errors } = await this.orderMember.membership.createMembershipOrder(this.periodStrategy, this.adminEndDate)
      this.loading = false
      if (errors && errors.length) {
        this.$mh.showErrors(errors)
      } else {
        this.order.id = order.id
        await this.order.fetch()
        this.$emit('membership-order-created')
      }
    },
    cannotBeMembershipOwnerReason (orderMember) {
      const reasons = []
      if (!orderMember.email) {
        reasons.push(_.toLower(this.$t('form.labels.emailAddress')))
      }
      if (!orderMember.defaultPaymentMethodId && !orderMember.membership.canHaveOwnerWithoutPaymentInfo) {
        reasons.push(_.toLower(this.$tc('payment.method', 1)))
      }
      return this.$t('membership.errors.nameCannotBeOwnerWithReasons', { name: orderMember.firstName, reasons: reasons.join(', ') })
    }
  }
}

</script>

<style lang="scss" scoped>
  .title {
    font-family: "Roboto", "-apple-system", "Helvetica Neue", Helvetica, Arial, sans-serif;
  }
  .selected {
    border: solid 4px;
    border-radius: 10px;
    border-color: var(--q-primary);
  }
</style>
